"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from "react";
import { Tv, Search } from "lucide-react";
import type { Labels } from "@/lib/labels/types";
import type { ResolvedListings } from "../utils/resolveMatchListings";
import { BroadcasterListItem } from "./BroadcasterListItem";
interface Props {
  resolved: ResolvedListings;
  labels: Labels;
}
function countryFlagUrl(code: string): string {
  return `https://flagcdn.com/w40/${code.toLowerCase()}.png`;
}
export function AllBroadcastersDialog(t0) {
  const $ = _c(52);
  const {
    resolved,
    labels
  } = t0;
  const [query, setQuery] = useState("");
  let t1;
  if ($[0] !== labels.countries || $[1] !== resolved.byCountry) {
    let t2;
    if ($[3] !== labels.countries) {
      t2 = (a, b) => {
        const na = labels.countries?.[a] ?? a;
        const nb = labels.countries?.[b] ?? b;
        return na.localeCompare(nb);
      };
      $[3] = labels.countries;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = Object.keys(resolved.byCountry).sort(t2);
    $[0] = labels.countries;
    $[1] = resolved.byCountry;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const sortedCountries = t1;
  let filtered;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[5] !== labels.countries || $[6] !== labels.tv.countryOne || $[7] !== labels.tv.countryOther || $[8] !== labels.tv.searchBroadcasters || $[9] !== labels.tv.seeAllBroadcasters || $[10] !== query || $[11] !== resolved.byCountry || $[12] !== sortedCountries) {
    const q = query.trim().toLowerCase();
    filtered = sortedCountries.map(c => {
      const list = resolved.byCountry[c].filter(l => {
        if (!q) {
          return true;
        }
        return l.channel.name.toLowerCase().includes(q) || (labels.countries?.[c] ?? c).toLowerCase().includes(q) || c.toLowerCase().includes(q);
      });
      return {
        country: c,
        list
      };
    }).filter(_temp);
    let t7;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = ["bg-background text-foreground", "rounded-xl overflow-hidden", "w-[min(36rem,calc(100vw-2rem))] max-h-[80vh]", "flex flex-col", "shadow-2xl"];
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    t4 = t7.join(" ");
    let t8;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = ["flex items-center gap-3", "px-5 py-4", "border-b border-border"];
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = ["inline-flex items-center justify-center", "w-9 h-9 rounded-full shrink-0", "[background-color:color-mix(in_srgb,var(--color-primary)_12%,transparent)]", "[color:var(--color-primary)]"];
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <span className={t9.join(" ")}><Tv className="w-4 h-4" aria-hidden="true" /></span>;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    let t11;
    if ($[23] !== labels.tv.seeAllBroadcasters) {
      t11 = <h2 className="m-0 text-base font-semibold leading-tight text-foreground">{labels.tv.seeAllBroadcasters}</h2>;
      $[23] = labels.tv.seeAllBroadcasters;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    let t12;
    if ($[25] !== labels.tv.countryOne || $[26] !== labels.tv.countryOther || $[27] !== sortedCountries.length) {
      t12 = sortedCountries.length > 0 && <p className="m-0 text-xs text-muted-foreground leading-tight mt-0.5">{(sortedCountries.length === 1 ? labels.tv.countryOne : labels.tv.countryOther).replace("{count}", String(sortedCountries.length))}</p>;
      $[25] = labels.tv.countryOne;
      $[26] = labels.tv.countryOther;
      $[27] = sortedCountries.length;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    if ($[29] !== t11 || $[30] !== t12) {
      t5 = <header className={t8.join(" ")}>{t10}<div className="flex-1 min-w-0">{t11}{t12}</div></header>;
      $[29] = t11;
      $[30] = t12;
      $[31] = t5;
    } else {
      t5 = $[31];
    }
    let t13;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none" aria-hidden="true" />;
      $[32] = t13;
    } else {
      t13 = $[32];
    }
    let t14;
    let t15;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = e => setQuery(e.target.value);
      t15 = ["w-full pl-9 pr-3 py-2", "rounded-md border border-border", "bg-muted/40 text-foreground text-sm", "placeholder:text-muted-foreground", "hover:bg-muted/60", "focus:outline-none focus:bg-background focus:border-primary focus:ring-2 focus:ring-primary/20", "transition-colors"];
      $[33] = t14;
      $[34] = t15;
    } else {
      t14 = $[33];
      t15 = $[34];
    }
    if ($[35] !== labels.tv.searchBroadcasters || $[36] !== query) {
      t6 = <div className="px-5 pt-4 pb-2"><div className="relative">{t13}<input type="search" placeholder={labels.tv.searchBroadcasters} value={query} onChange={t14} className={t15.join(" ")} /></div></div>;
      $[35] = labels.tv.searchBroadcasters;
      $[36] = query;
      $[37] = t6;
    } else {
      t6 = $[37];
    }
    t2 = "flex-1 overflow-y-auto px-5 pb-5";
    let t16;
    if ($[38] !== labels.countries) {
      t16 = t17 => {
        const {
          country,
          list: list_0
        } = t17;
        const countryName = labels.countries?.[country] ?? country;
        return <section key={country} className="mt-4 first:mt-2"><h3 className="flex items-center gap-2 my-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground"><img src={countryFlagUrl(country)} alt="" width={20} height={14} className="rounded-sm shadow-sm" loading="lazy" /><span>{countryName}</span><span className="opacity-50 font-normal normal-case tracking-normal">· {list_0.length}</span></h3><ul className="list-none p-0 m-0 flex flex-wrap gap-2">{list_0.map(_temp2)}</ul></section>;
      };
      $[38] = labels.countries;
      $[39] = t16;
    } else {
      t16 = $[39];
    }
    t3 = filtered.map(t16);
    $[5] = labels.countries;
    $[6] = labels.tv.countryOne;
    $[7] = labels.tv.countryOther;
    $[8] = labels.tv.searchBroadcasters;
    $[9] = labels.tv.seeAllBroadcasters;
    $[10] = query;
    $[11] = resolved.byCountry;
    $[12] = sortedCountries;
    $[13] = filtered;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    filtered = $[13];
    t2 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
  }
  let t7;
  if ($[40] !== filtered.length || $[41] !== labels.common) {
    t7 = filtered.length === 0 && <p className="text-sm text-muted-foreground py-6 text-center">{labels.common.noResults}</p>;
    $[40] = filtered.length;
    $[41] = labels.common;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  let t8;
  if ($[43] !== t2 || $[44] !== t3 || $[45] !== t7) {
    t8 = <div className={t2}>{t3}{t7}</div>;
    $[43] = t2;
    $[44] = t3;
    $[45] = t7;
    $[46] = t8;
  } else {
    t8 = $[46];
  }
  let t9;
  if ($[47] !== t4 || $[48] !== t5 || $[49] !== t6 || $[50] !== t8) {
    t9 = <div className={t4}>{t5}{t6}{t8}</div>;
    $[47] = t4;
    $[48] = t5;
    $[49] = t6;
    $[50] = t8;
    $[51] = t9;
  } else {
    t9 = $[51];
  }
  return t9;
}
function _temp2(l_0) {
  return <li key={l_0.id}><BroadcasterListItem listing={l_0} variant="card" /></li>;
}
function _temp(c_0) {
  return c_0.list.length > 0;
}